module.exports = __webpack_public_path__ + "assets/img/sy-4.4a51e031.png";